// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import {
    UpdatePrice as baseUpdatePrice,
    chain,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateUnitOfMeasure";
import { getKitConfigurationOptionIds } from "@store/Framework/Utilities/KitProductInfoUtilities";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const UpdatePrice = createChainHandler("UpdatePrice", chain, async props => {
    if (props.reloadAllLines || !props.apiResult || props.apiResult.quoteRequired) {
        return;
    }

    let loadedPricing = false;
    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: [
                {
                    productId: props.apiResult.productId,
                    unitOfMeasure: props.apiResult.unitOfMeasure,
                    qtyOrdered: props.apiResult.qtyOrdered,
                    configuration: getKitConfigurationOptionIds(props.apiResult), // Store Custom Code
                },
            ],
            onComplete: realTimePricingProps => {
                if (realTimePricingProps.apiResult) {
                    props.pricing = realTimePricingProps.apiResult.realTimePricingResults?.find(
                        o => o.productId === props.apiResult.productId,
                    );
                } else if (realTimePricingProps.error) {
                    props.failedToLoadPricing = true;
                }

                loadedPricing = true;
            },
        }),
    );

    await waitFor(() => loadedPricing);
});

replaceInChain(chain, baseUpdatePrice, UpdatePrice);
